"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOptions = void 0;
const react_1 = require("react");
const roadTypes_1 = __importDefault(require("../constants/roadTypes"));
function useOptions({ cities, provinces }) {
    const cityOptions = (0, react_1.useMemo)(() => cities.map(({ city }) => ({ label: city, value: city })), [cities]);
    const provinceOptions = (0, react_1.useMemo)(() => provinces.map(({ postalCode, description }) => ({ label: description, value: postalCode })), [provinces]);
    const roadTypeOptions = (0, react_1.useMemo)(() => roadTypes_1.default.map(description => ({ label: description, value: description })), []);
    return {
        addressSuggestionsOptions: [],
        roadTypeOptions,
        cityOptions,
        provinceOptions,
    };
}
exports.useOptions = useOptions;
//# sourceMappingURL=useOptions.js.map